import { buildCollection } from "@firecms/core";
import { rolesOf } from "../roles";

export const inquiriesCollection = buildCollection({
  id: "inquiries",
  path: "inquiries",
  name: "線上詢問",
  singularName: "詢問",
  group: "營運",
  icon: "mail",
  description: "官網「線上詢問」表單送來的訊息，同時也會轉寄到客服信箱。",
  permissions: ({ authController }) => {
    const r = rolesOf(authController);
    return { read: r.staff, edit: r.staff, create: false, delete: r.admin };
  },
  initialSort: ["createdAt", "desc"],
  properties: {
    status: {
      name: "狀態",
      dataType: "string",
      enumValues: {
        open: { id: "open", label: "待回覆", color: "orangeLight" },
        answered: { id: "answered", label: "已回覆", color: "greenLight" },
        closed: { id: "closed", label: "結案", color: "grayLight" },
      },
    },
    createdAt: { name: "時間", dataType: "date", readOnly: true },
    name: { name: "姓名", dataType: "string", readOnly: true },
    email: { name: "Email", dataType: "string", readOnly: true, email: true },
    orderNo: { name: "訂單編號", dataType: "string", readOnly: true },
    locale: { name: "語系", dataType: "string", readOnly: true },
    message: { name: "內容", dataType: "string", multiline: true, readOnly: true },
  },
});
